import React from 'react';
import Cookies from 'js-cookie';
import confetti from 'canvas-confetti';
import styles from '../LiveResume.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';

export default class LiveResumeQuizVerification extends React.Component {

	constructor(props) {
		super(props);

		this.questionTimer = null;
		this.answerAdvanceTimer = null;

        this.screens = {
            Processing: 1,
			Questions: 2,
			Results: 3,
        };

		// testing
		// this.verificationQuestions = [
		// 	{
		// 		userEntityLiveResumeChoiceQuestionId: 1,
		// 		userEntityLiveResumeId: 123,
		// 		questionOrderNum: 1,
		// 		question: 'What is the capital of France?',
		// 		optionA: 'Berlin',
		// 		optionB: 'Madrid',
		// 		optionC: 'Paris',
		// 		optionD: 'Rome',
		// 		createdAt: '2024-01-01T00:00:00Z',
		// 	},
		// 	{
		// 		userEntityLiveResumeChoiceQuestionId: 2,
		// 		userEntityLiveResumeId: 123,
		// 		questionOrderNum: 2,
		// 		question: 'Which planet is known as the Red Planet?',
		// 		optionA: 'Earth',
		// 		optionB: 'Mars',
		// 		optionC: 'Jupiter',
		// 		optionD: 'Venus',
		// 		createdAt: '2024-01-01T00:00:00Z',
		// 	},
		// 	{
		// 		userEntityLiveResumeChoiceQuestionId: 3,
		// 		userEntityLiveResumeId: 123,
		// 		questionOrderNum: 3,
		// 		question: 'What is the largest ocean on Earth?',
		// 		optionA: 'Atlantic Ocean',
		// 		optionB: 'Indian Ocean',
		// 		optionC: 'Arctic Ocean',
		// 		optionD: 'Pacific Ocean',
		// 		createdAt: '2024-01-01T00:00:00Z',
		// 	}
		// ];
		

		this.state = {
            currentScreen: this.screens.Processing,

			currentLiveResumeID: this.props.liveResumeID,

			// testing
			// currentLiveResumeID: 1,

			verificationQuestions: [],
			verificationAnswersByQuestionID: {},
			selectedAnswersByQuestionID: {},
			learningIntentQuestionIDs: [],
			verificationMisses: [],
			correctAnswerCount: 0,

			isLoading: true,

			errorText: '',
			verificationErrorText: '',
			processingMessageIndex: 0,
			currentQuestionIndex: 0,
			selectedAnswerIndexes: [],
			questionTimeLeft: 60,
		};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		this.clearAllVerificationTimers();
        this.getAndProcessQuizQuestions();

		// testing
		// const normalizedQuestionRows = this.verificationQuestions;

		// const verificationQuestions = normalizedQuestionRows.map((row) => ({
		// 	questionID: Number(row.userEntityLiveResumeChoiceQuestionId),
		// 	question: row.question || '',
		// 	options: [row.optionA, row.optionB, row.optionC, row.optionD].map((optionValue) => optionValue || ''),
		// }));

		// this.setState({
		// 	verificationQuestions,
		// 	verificationAnswersByQuestionID: {},
		// 	selectedAnswersByQuestionID: {},
		// 	learningIntentQuestionIDs: [],
		// 	verificationMisses: [],
		// 	correctAnswerCount: 0,
		// 	isLoading: false,
		// }, this.startVerificationFlow);
		// testign end

	}

	componentWillUnmount() {
		this.clearAllVerificationTimers();
	};

	getAndProcessQuizQuestions = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);

		try {
			const response = await utils.sendRequest('/liveResume/getAndProcessLiveResumeQuestions', {
				liveResumeID,
			});

			const questionRows = Array.isArray(response && response.questions)
				? response.questions
				: (Array.isArray(response && response.choiceQuestions) ? response.choiceQuestions : []);

			if (!questionRows.length) {
				throw new Error('Could not generate verification questions right now. Please try again.');
			}

			const normalizedQuestionRows = Array.isArray(questionRows) ? questionRows : [];

			const verificationQuestions = normalizedQuestionRows.map((row) => ({
				questionID: Number(row.userEntityLiveResumeChoiceQuestionId),
				question: row.question || '',
				options: [row.optionA, row.optionB, row.optionC, row.optionD].map((optionValue) => optionValue || ''),
			}));

			this.setState({
				verificationQuestions,
				verificationAnswersByQuestionID: {},
				selectedAnswersByQuestionID: {},
				learningIntentQuestionIDs: [],
				verificationMisses: [],
				correctAnswerCount: 0,
				isLoading: false,
			}, this.startVerificationFlow);
		} catch (error) {
			this.clearAllVerificationTimers();
			this.setState({
				isLoading: false,
				errorText: error && error.message ? error.message : 'Could not generate verification questions right now.',
				verificationErrorText: '',
			});
		}
	};

	answerLettersToIndexes = (rawAnswer) => {
		const normalized = String(rawAnswer || '')
			.trim()
			.toUpperCase();

		if (!normalized) {
			return [];
		}

		const letterToIndex = {
			A: 0,
			B: 1,
			C: 2,
			D: 3,
		};

		// Accept formats like "A,C", "A and C", "A / C", "A. C", and even "AC".
		let tokens = normalized.match(/\b[ABCD]\b/g) || [];

		if (!tokens.length) {
			tokens = normalized.split('').filter((char) => Object.prototype.hasOwnProperty.call(letterToIndex, char));
		}

		const indexes = tokens
			.map((item) => letterToIndex[item])
			.filter((item) => Number.isInteger(item));

		return Array.from(new Set(indexes)).sort((a, b) => a - b);
	};

	saveVerificationAnswer = (questionAnswers) => {
		const liveResumeID = Number(this.state.currentLiveResumeID);
		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			return;
		}

		const answers = Array.isArray(questionAnswers) ? questionAnswers : [];

		return utils.sendRequest('/liveResume/saveLiveResumeAnswers', {
			liveResumeID,
			questionAnswers: answers,
		})
		.catch((error) => {
			console.log(error && error.message ? error.message : error);
		});
	};

	areAnswerSetsEqual = (leftIndexes, rightIndexes) => {
		const left = Array.isArray(leftIndexes) ? Array.from(new Set(leftIndexes)).sort((a, b) => a - b) : [];
		const right = Array.isArray(rightIndexes) ? Array.from(new Set(rightIndexes)).sort((a, b) => a - b) : [];

		if (left.length !== right.length) {
			return false;
		}

		for (let index = 0; index < left.length; index += 1) {
			if (left[index] !== right[index]) {
				return false;
			}
		}

		return true;
	};

	triggerSavedConfetti = () => {
		confetti({ particleCount: 150, spread: 70, origin: { y: 0.6 } });
	};

    startVerificationFlow = () => {
        this.setState({
            currentScreen: this.screens.Questions,
            selectedAnswerIndexes: this.state.selectedAnswersByQuestionID[this.state.verificationQuestions[0].questionID] || [],
            questionTimeLeft: 60,
        }, () => {
            this.setVerificationQuestionTimer();
        });
    };

	clearAllVerificationTimers = () => {
		if (this.questionTimer) {
			window.clearInterval(this.questionTimer);
			this.questionTimer = null;
		}

		if (this.answerAdvanceTimer) {
			window.clearTimeout(this.answerAdvanceTimer);
			this.answerAdvanceTimer = null;
		}
	};

	setVerificationQuestionTimer = () => {
		if (this.questionTimer) {
			window.clearInterval(this.questionTimer);
		}

		this.questionTimer = window.setInterval(() => {
			this.setState((prevState) => {
				if (prevState.currentScreen !== this.screens.Questions) {
					return null;
				}

				if (prevState.questionTimeLeft <= 1) {
					window.clearInterval(this.questionTimer);
					this.questionTimer = null;
					this.gotoResultVerification('Verification expired because the question timer reached zero.');
					return null;
				}

				return {
					questionTimeLeft: prevState.questionTimeLeft - 1,
				};
			});
		}, 1000);
	};

	goToNextVerificationQuestion = () => {
		const currentQuestion = this.state.verificationQuestions[this.state.currentQuestionIndex];
		if (!currentQuestion) {
			this.gotoResultVerification('Could not load the current verification question.');
			return;
		}

		if (!Array.isArray(this.state.selectedAnswerIndexes) || this.state.selectedAnswerIndexes.length === 0) {
			this.setState({
				verificationErrorText: 'Select an answer before continuing.',
			});
			return;
		}

		const totalQuestions = this.state.verificationQuestions.length;
		const nextQuestionIndex = this.state.currentQuestionIndex + 1;
		const isFinalQuestion = nextQuestionIndex >= totalQuestions;

		this.clearAllVerificationTimers();

		if (isFinalQuestion) {
			this.verifySelectedAnswers();
			return;
		}

		const nextQuestion = this.state.verificationQuestions[nextQuestionIndex];

		this.setState({
			currentQuestionIndex: nextQuestionIndex,
			selectedAnswerIndexes: nextQuestion ? (this.state.selectedAnswersByQuestionID[nextQuestion.questionID] || []) : [],
			questionTimeLeft: 60,
			verificationErrorText: '',
		}, () => {
			this.setVerificationQuestionTimer();
		});
	};

	verifySelectedAnswers = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);
		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.gotoResultVerification('No live resume is loaded for answer verification. Please save again.');
			return;
		}

		this.setState({
			isLoading: true,
			verificationErrorText: '',
		});

		try {
			const questionAnswers = this.state.verificationQuestions.map((question) => ({
				questionID: question.questionID,
				chosenAnswer: (this.state.selectedAnswersByQuestionID[question.questionID] || [])
					.map((answerIndex) => String.fromCharCode(65 + answerIndex))
					.join(','),
			}));

			const answersResponse = await utils.sendRequest('/liveResume/getLiveResumeAnswers', {
				liveResumeID,
			});

			const answerRows = answersResponse && Array.isArray(answersResponse.answers)
				? answersResponse.answers
				: [];

			const verificationAnswersByQuestionID = {};
			const answerExplanationByQuestionID = {};
			answerRows.forEach((row) => {
				const questionID = Number(row.userEntityLiveResumeChoiceQuestionId);
				verificationAnswersByQuestionID[questionID] = this.answerLettersToIndexes(row.answers);
				answerExplanationByQuestionID[questionID] = row.answerExplanation || '';
			});

			const verificationMisses = [];
			let correctAnswerCount = 0;
			this.state.verificationQuestions.forEach((question) => {
				const selectedAnswerIndexes = this.state.selectedAnswersByQuestionID[question.questionID] || [];
				const correctAnswerIndexes = verificationAnswersByQuestionID[question.questionID] || [];
				const isCorrect = this.areAnswerSetsEqual(selectedAnswerIndexes, correctAnswerIndexes);

				if (isCorrect) {
					correctAnswerCount += 1;
				}
				else {
					verificationMisses.push({
						questionID: question.questionID,
						question: question.question,
						options: question.options,
						selectedAnswerIndexes,
						correctAnswerIndexes,
						answerExplanation: answerExplanationByQuestionID[question.questionID] || '',
					});
				}
			});

			await this.saveVerificationAnswer(questionAnswers);

			const shouldTriggerConfetti = correctAnswerCount > 0;

			if (verificationMisses.length > 0) {
				this.setState({
					isLoading: false,
					currentScreen: this.screens.Results,
					verificationAnswersByQuestionID,
					verificationMisses,
					correctAnswerCount,
					errorText: `${verificationMisses.length} answer${verificationMisses.length > 1 ? 's were' : ' was'} missed.`,
					verificationErrorText: `${verificationMisses.length} answer${verificationMisses.length > 1 ? 's were' : ' was'} missed.`,
					selectedAnswerIndexes: [],
					questionTimeLeft: 0,
				}, () => {
					if (shouldTriggerConfetti) {
						this.triggerSavedConfetti();
					}
				});
				return;
			}

			this.setState({
				isLoading: false,
				verificationAnswersByQuestionID,
				verificationMisses: [],
				currentScreen: this.screens.Results,
				correctAnswerCount,
				verificationErrorText: '',
				selectedAnswerIndexes: [],
				questionTimeLeft: 60,
			}, () => {
				if (shouldTriggerConfetti) {
					this.triggerSavedConfetti();
				}
			});
		} catch (error) {
			this.setState({
				isLoading: false,
				verificationErrorText: error && error.message ? error.message : 'Could not verify answers right now.',
				errorText: error && error.message ? error.message : 'Could not verify answers right now.',
				currentScreen: this.screens.Results,
			});
		}
	};

	gotoResultVerification = (message) => {
		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.Results,
			verificationErrorText: message || this.state.verificationErrorText,
			errorText: message || this.state.errorText,
		});
	};

	handleAnswerSelect = (answerIndex) => {
		const {
			currentScreen,
			currentQuestionIndex,
			verificationQuestions,
			selectedAnswerIndexes,
		} = this.state;

		if (currentScreen !== this.screens.Questions) {
			return;
		}

		const currentQuestion = verificationQuestions[currentQuestionIndex];
		if (!currentQuestion) {
			this.gotoResultVerification('Could not load the current verification question.');
			return;
		}

		const questionID = currentQuestion.questionID;
		const currentSelectedAnswerIndexes = Array.isArray(selectedAnswerIndexes) ? selectedAnswerIndexes : [];
		const nextSelectedAnswerIndexes = currentSelectedAnswerIndexes[0] === answerIndex
			? []
			: [answerIndex];

		const nextLearningIntentQuestionIDs = nextSelectedAnswerIndexes.includes(4)
			? Array.from(new Set([...this.state.learningIntentQuestionIDs, questionID]))
			: this.state.learningIntentQuestionIDs.filter((item) => item !== questionID);

		this.setState({
			selectedAnswerIndexes: nextSelectedAnswerIndexes,
			selectedAnswersByQuestionID: {
				...this.state.selectedAnswersByQuestionID,
				[questionID]: nextSelectedAnswerIndexes,
			},
			learningIntentQuestionIDs: nextLearningIntentQuestionIDs,
			verificationErrorText: '',
		});
	};

	continueVerification = () => {
		this.props.onContinueVerification(this.state.correctAnswerCount);

		// if (typeof this.props.passVerification === 'function') {
		// 	this.props.passVerification({
		// 		liveResumeID: Number(this.state.currentLiveResumeID),
		// 		correctAnswerCount: this.state.correctAnswerCount,
		// 		verificationScoreLabel: this.state.verificationScoreLabel,
		// 	});
		// 	return;
		// }

		// window.location.href = '/dashboard';
	};
	// This is for when we need to have multiple answers selected for a question (not currently used)
	// handleAnswerSelect_old = (answerIndex) => {
	// 	const {
	// 		currentScreen,
	// 		currentQuestionIndex,
	// 		verificationQuestions,
	// 		selectedAnswerIndexes,
	// 	} = this.state;

	// 	if (currentScreen !== this.screens.Questions) {
	// 		return;
	// 	}

	// 	const currentQuestion = verificationQuestions[currentQuestionIndex];
	// 	if (!currentQuestion) {
	// 		this.gotoResultVerification('Could not load the current verification question.');
	// 		return;
	// 	}

	// 	const questionID = currentQuestion.questionID;
	// 	const currentSelectedAnswerIndexes = Array.isArray(selectedAnswerIndexes) ? selectedAnswerIndexes : [];
	// 	const nextSelectedAnswerIndexes = currentSelectedAnswerIndexes.includes(answerIndex)
	// 		? currentSelectedAnswerIndexes.filter((item) => item !== answerIndex)
	// 		: [...currentSelectedAnswerIndexes, answerIndex].sort((a, b) => a - b);

	// 	const nextLearningIntentQuestionIDs = nextSelectedAnswerIndexes.includes(4)
	// 		? Array.from(new Set([...this.state.learningIntentQuestionIDs, questionID]))
	// 		: this.state.learningIntentQuestionIDs.filter((item) => item !== questionID);

	// 	this.setState({
	// 		selectedAnswerIndexes: nextSelectedAnswerIndexes,
	// 		selectedAnswersByQuestionID: {
	// 			...this.state.selectedAnswersByQuestionID,
	// 			[questionID]: nextSelectedAnswerIndexes,
	// 		},
	// 		learningIntentQuestionIDs: nextLearningIntentQuestionIDs,
	// 		verificationErrorText: '',
	// 	});
	// };

	renderProcessingScreen = () => {
		const {
			errorText,
		} = this.state;

		return (
			<>
				<section className={styles.mainCardPanel}>
					<h2 className={styles.formTitle}>Verification Question</h2>
					<p className={styles.formText}>Loading verification questions...</p>

					<div className={styles.verificationWrap}>
						<div className={styles.verificationBanner}>Loading verification questions...</div>
					</div>

					{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
				</section>
			</>
		);
	};

	renderQuestionsScreen = () => {
		const {
			currentQuestionIndex,
			selectedAnswerIndexes,
			questionTimeLeft,
			verificationQuestions,
			isLoading,
			errorText,
		} = this.state;

		const currentQuestion = verificationQuestions[currentQuestionIndex];
		const totalQuestions = verificationQuestions.length;

		return (
			<>
				<section className={styles.mainCardPanel}>
					<h2 className={styles.formTitle}>Verification Question {currentQuestionIndex + 1}</h2>
					<p className={styles.formText}>Choose the best option and press Next.</p>

					<div className={styles.verificationWrap}>
						<div className={styles.verificationTopRow}>
							<div className={styles.verificationPill}>Question {currentQuestionIndex + 1} of {totalQuestions}</div>
							<div className={styles.verificationPill}>{questionTimeLeft}s remaining</div>
						</div>

						{/* <div className={styles.verificationBanner}>
							Choose the best option and press Next.
						</div> */}

						<div className={styles.questionCard}>
							<h3 className={styles.questionText}>{currentQuestion.question}</h3>

							<div className={styles.optionsList}>
								{
									// [...currentQuestion.options, "I don't know the answer, but I want to learn about this"].map((option, optionIndex) => {
									currentQuestion.options.map((option, optionIndex) => {
										const isSelected = Array.isArray(selectedAnswerIndexes) && selectedAnswerIndexes.includes(optionIndex);
										const optionClassName = [
											styles.optionButton,
											isSelected ? styles.optionButtonSelected : '',
										].filter(Boolean).join(' ');

										return (
											<button
												key={`${currentQuestionIndex}-${optionIndex}`}
												className={optionClassName}
												onClick={() => this.handleAnswerSelect(optionIndex)}
												disabled={isLoading}
											>
												<span className={styles.optionLetter}>{String.fromCharCode(65 + optionIndex)}.</span>
												<span className={styles.optionText}>{option}</span>
											</button>
										);
									})
								}
							</div>

							{this.state.verificationErrorText !== '' && <div className={styles.errorBox}>{this.state.verificationErrorText}</div>}

							<button
								className={styles.primaryButton}
								onClick={this.goToNextVerificationQuestion}
								disabled={!Array.isArray(selectedAnswerIndexes) || selectedAnswerIndexes.length === 0 || isLoading}
							>
								{currentQuestionIndex + 1 === totalQuestions ? (isLoading ? 'Checking...' : 'Finish & Check Answers') : 'Next'}
							</button>
						</div>
					</div>

					{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
				</section>
			</>
		);
	};

	renderResultsScreen = () => {
		const {
			verificationErrorText,
			verificationMisses,
			errorText,
			verificationQuestions,
			correctAnswerCount,
		} = this.state;

		const hasMissedAnswers = Array.isArray(verificationMisses) && verificationMisses.length > 0;
		const totalQuestions = Array.isArray(verificationQuestions) && verificationQuestions.length > 0
			? verificationQuestions.length
			: 3;

		return (
			<>
				<section className={styles.mainCardPanel}>
					<h2 className={styles.formTitle}>Verification Results</h2>
					{/* <p className={styles.formText}>{hasMissedAnswers ? 'Some answers were missed. Review the details below.' : 'The verification session was interrupted.'}</p> */}

					<div className={styles.verificationWrap}>
						{/* <div className={styles.successIcon}>{hasMissedAnswers ? 'Verification result' : 'Verification stopped'}</div> */}
						{
							correctAnswerCount >= 3 ?
							<h3 className={styles.successTitle}>You got all answers correct!</h3> :
							<h3 className={styles.successTitle}>Some questions were missed. Review the details below.</h3>
						}
						
						{/* <p className={styles.failureText}>{verificationErrorText || 'The verification session was interrupted.'}</p> */}
						{/* <div className={styles.failureBadge}>Score: {this.getVerificationScoreLabel(correctAnswerCount)} ({correctAnswerCount}/{totalQuestions})</div> */}

						{
							hasMissedAnswers &&
							<div className={styles.processingLabel}>Score: ({correctAnswerCount}/{totalQuestions})</div>
						}

						{hasMissedAnswers && (
							<div className={styles.missedAnswersList}>
								{verificationMisses.map((item) => {
									const baseOptions = Array.isArray(item.options) ? item.options : [];
									const selectedAnswerIndexes = Array.isArray(item.selectedAnswerIndexes) ? item.selectedAnswerIndexes : [];
									const correctAnswerIndexes = Array.isArray(item.correctAnswerIndexes) ? item.correctAnswerIndexes : [];

									return (
										<div key={`missed-${item.questionID}`} className={styles.missedAnswerCard}>
											<div className={styles.missedAnswerQuestion}>{item.question}</div>

											<div className={styles.reviewOptionsList}>
												{baseOptions.map((optionText, optionIndex) => {
													const isSelected = selectedAnswerIndexes.includes(optionIndex);
													const isCorrect = correctAnswerIndexes.includes(optionIndex);
													const rowClass = [
														styles.reviewOptionRow,
														isCorrect ? styles.reviewOptionCorrect : '',
														isSelected && !isCorrect ? styles.reviewOptionWrong : '',
													].filter(Boolean).join(' ');

													return (
														<div key={`review-${item.questionID}-${optionIndex}`} className={rowClass}>
															<span className={styles.reviewOptionLetter}>{String.fromCharCode(65 + optionIndex)}.</span>
															<span className={styles.reviewOptionText}>{optionText}</span>
															{isSelected && <span className={styles.reviewSelectedTag}>Selected</span>}
															{isCorrect && <span className={styles.reviewCheckIcon}>Correct</span>}
														</div>
													);
												})}
											</div>

											{item.answerExplanation && <div className={styles.missedAnswerMeta}>Explanation: {item.answerExplanation}</div>}
										</div>
									);
								})}
							</div>
						)}

						<div className={styles.failureActions}>
							<button className={styles.primaryButton} onClick={this.continueVerification}>
								Continue
							</button>
						</div>
					</div>

					{/* {errorText !== '' && <div className={styles.errorBox}>{errorText}</div>} */}
				</section>
			</>
		);
	};

	// renderSuccessScreen = () => {
	// 	const successCopy = {
    //         icon: 'Verified',
    //         title: 'Live Resume Verified',
    //         text: '',
    //     };
// Verification interrupted
	// 	return (
	// 		<>
	// 			<section className={styles.mainCardPanel}>
	// 				<h2 className={styles.formTitle}>Verification Complete</h2>
	// 				<p className={styles.formText}>Your update passed verification.</p>

	// 				<div className={styles.successWrap}>
	// 					<div className={styles.successIcon}>{successCopy.icon}</div>
	// 					<h3 className={styles.successTitle}>{successCopy.title}</h3>
	// 					<p className={styles.successText}>{successCopy.text}</p>
	// 					<div className={styles.failureActions}>
	// 						{/* <button className={styles.primaryButton} onClick={this.goToDashboard}>
	// 							Back To Dashboard
	// 						</button>
	// 						<button className={styles.secondaryButton} onClick={this.goBackToComposer}>
	// 							Save Another Update
	// 						</button> */}
	// 					</div>
	// 				</div>

	// 				{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
	// 			</section>
	// 		</>
	// 	);
	// };

	renderCurrentScreen = () => {
		const {
			currentScreen,
		} = this.state;

		if (currentScreen === this.screens.Processing) {
			return this.renderProcessingScreen();
		}
		else if (currentScreen === this.screens.Questions) {
			return this.renderQuestionsScreen();
		}
		else if (currentScreen === this.screens.Results) {
			return this.renderResultsScreen();
		}
	};

	render() {
		return this.renderCurrentScreen();
	};
}
